import {Button, HStack, ModalBody, ModalCloseButton, ModalFooter, ModalHeader} from "@chakra-ui/react";
import type {RoleId, UserMin} from "../../Types";
import {useCallback, useState} from "react";
import {withModal} from "../../state/withModal";
import {UserPicker, UserPickerValue} from "../../components/UserPicker";
import api from "../../api";
import {usePromiseState} from "../../hooks/promiseState";
import {useModalContext} from "../../components/modals";
import {inviteUserDialog} from ".";

const AddRoleMemberModal = withModal(({onClose, roleId}: {onClose: () => void; roleId: RoleId}) => {
  const {open} = useModalContext();
  const [userOrInvite, setUserOrInvite] = useState<UserPickerValue>({type: "Invite", nameOrEmail: ""});

  const addUser = useCallback(
    async (user: UserMin) => {
      await api.roles.addMember(roleId, user.user_id);
    },
    [roleId],
  );
  const [adding, add] = usePromiseState(async () => {
    if (userOrInvite?.type === "User") {
      await addUser(userOrInvite.user);
    } else if (userOrInvite?.type === "Invite") {
      const initialInviteName =
        userOrInvite?.type === "Invite" && !userOrInvite.nameOrEmail.includes("@") ? userOrInvite.nameOrEmail : "";
      const initialInviteEmail =
        userOrInvite?.type === "Invite" && userOrInvite.nameOrEmail.includes("@") ? userOrInvite.nameOrEmail : "";

      setTimeout(
        () =>
          open(inviteUserDialog, {onInvite: addUser, initialName: initialInviteName, initialEmail: initialInviteEmail}),
        200,
      );
    }
    onClose();
  }, [addUser, onClose, open, userOrInvite]);

  return (
    <>
      <ModalHeader>Add member</ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        <UserPicker value={userOrInvite} onSelect={setUserOrInvite} onSubmit={add} autoFocus />
      </ModalBody>
      <ModalFooter>
        <HStack spacing="3">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            onClick={add}
            isDisabled={!userOrInvite || adding.inProgress}
            isLoading={adding.inProgress}
          >
            {userOrInvite?.type === "Invite" ? "Invite and add" : "Add"}
          </Button>
        </HStack>
      </ModalFooter>
    </>
  );
});

export default AddRoleMemberModal;
